const PaymentMethod = {
  CREDIT: 1,
  BANK_SLIP: 2,
  PIX: 3,
};

export default PaymentMethod;
